import React from "react"
import { Card, CardBody, CardHeader } from "reactstrap"
import { ProposalListAnyContainer } from "components/proposals/redux/ProposalContainers"
import Icon from "components/common/Icon"

const ProposalCardAnyBasic = () => {
    return (
        <Card>
            <CardHeader>
                <h6>
                    <Icon proposal />
                    All Proposals
                </h6>
            </CardHeader>
            <CardBody>
                <ProposalListAnyContainer />
            </CardBody>
        </Card >
    )
}

export default ProposalCardAnyBasic
